import { Component, Input } from '@angular/core';
import { Customer, CustomerMedicalNotes, CustomerNote } from '../../../../../../../models/customer';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-add-customer-medical-notes-modal',
  templateUrl: './add-customer-medical-notes-modal.component.html',
  styleUrls: ['./add-customer-medical-notes-modal.component.css']
})
export class AddCustomerMedicalNotesModalComponent {

  @Input() customer: Customer;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public notes: CustomerMedicalNotes = {
    id: null,
    url: '',
    medical_notes: '',
    created_at: '',
    updated_at: ''
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .addCustomerMedicalNotes(
        this.customer.id,
        this.notes
      )
      .then(note => {
        this.savedCallback({
          text: 'Medical notes created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create these medical notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
